import PropTypes from 'prop-types';
import clsx from 'clsx';

const defaultProps = {
  className: null,
  error: null,
  touched: false,
  hasError: false,
  light: true,
  disabled: false,
};

const propTypes = {
  className: PropTypes.string,
  error: PropTypes.string,
  touched: PropTypes.bool,
  hasError: PropTypes.bool,
  light: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default function TextAreaControl({
  className,
  disabled,
  error,
  touched,
  hasError,
  light,
  ...rest
}) {
  const hasErrorFinal = hasError || (error !== null && touched === true);

  let finalClasses = ['border rounded-md focus:ring-2 focus:border-transparent focus:bg-white block w-full text-base px-3 focus:outline-none font-medium placeholder-gray-400'];

  if (light) {
    finalClasses = [
      ...finalClasses,
      'border-transparent',
      hasErrorFinal === false && 'bg-gray-100 focus:ring-green-200',
      hasErrorFinal === true && 'bg-red-50 focus:ring-red-200',
    ];
  } else {
    finalClasses = [
      ...finalClasses,
      'bg-white',
      'shadow-sm',
      hasErrorFinal === false && 'border-gray-400 bg-white focus:ring-green-500',
      hasErrorFinal === true && 'border-red-400 bg-red-50 focus:border-transparent focus:ring-red-500',
    ];
  }

  return (
    <textarea
      className={clsx(
        finalClasses,
        disabled === true && 'pointer-events-none opacity-70',
        className,
      )}
      rows={4}
      disabled={disabled}
      {...rest}
    />
  );
}

TextAreaControl.defaultProps = defaultProps;
TextAreaControl.propTypes = propTypes;
